export * from '@dynatrace/strato-components/tables';
